import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { Observable } from "rxjs";
import { GdEventReportDto, ResponseGdEventSendEmailDto } from "../dto/gd-event-report.dto";

@Injectable()
export class GdEventReportApi {
    private service: string = '';
    private model: string = 'events/report';
    private modelData: string = 'events';

    constructor(
        private nestApiProvider: NestApiProvider) {
    }

    preview() {
    }

    getEventData(data: GdEventReportDto): Observable<any> {
        const method: string = 'GET';
        const func: string = 'getEventData';
        const params: GdEventReportDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.modelData, func, params, urlParams, this.service);
        return this.nestApiProvider.request(method, url, func, params, body);
    }

    downloadExcel(data: GdEventReportDto) {
        const method: string = 'POST';
        const func: string = 'downloadExcel';
        const params: GdEventReportDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
    }

    downloadPdf(data: GdEventReportDto) {
        const method: string = 'POST';
        const func: string = 'downloadPdf';
        const params: GdEventReportDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
    }

    reportSendEmailExcel(data: GdEventReportDto): Observable<ResponseGdEventSendEmailDto> {
        const method: string = 'POST';
        const func: string = 'reportSendEmailExcel';
        const params: GdEventReportDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseGdEventSendEmailDto>(method, url, params, urlParams, body);
    }

    public reportSendEmailPdf(data: GdEventReportDto): Observable<ResponseGdEventSendEmailDto> {
        const method: string = 'POST';
        const func: string = 'reportSendEmailPdf';
        const params: GdEventReportDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseGdEventSendEmailDto>(method, url, params, urlParams, body);
    }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/gd-event-report.api.ts